/**
 * Animation Variants
 * Reusable Framer Motion animations for ages 3-6
 */

import { Variants } from 'framer-motion';

export const animations = {
  // Celebration animations
  celebrate: {
    scale: [1, 1.2, 1.1, 1.2, 1],
    rotate: [0, -5, 5, -5, 0],
    transition: {
      duration: 0.8,
      ease: 'easeInOut',
      times: [0, 0.2, 0.4, 0.6, 1],
    },
  } as Variants,

  // Bounce (for excited elements)
  bounce: {
    y: [0, -20, 0, -10, 0],
    transition: {
      duration: 0.6,
      ease: 'easeOut',
      repeat: Infinity,
      repeatDelay: 0.3,
    },
  } as Variants,

  // Wiggle (for attention)
  wiggle: {
    rotate: [0, -10, 10, -10, 10, 0],
    transition: {
      duration: 0.5,
      ease: 'easeInOut',
      repeat: 2,
    },
  } as Variants,

  // Grow (for plants, achievements)
  grow: {
    scale: [0, 1.1, 1],
    opacity: [0, 1, 1],
    transition: {
      duration: 1.0,
      ease: 'easeOut',
    },
  } as Variants,

  // Hop (for bunny, frog)
  hop: {
    y: [0, -50, 0],
    x: [0, 30, 60],
    rotate: [0, -10, 0],
    transition: {
      duration: 0.5,
      ease: 'easeInOut',
    },
  } as Variants,

  // Fade in
  fadeIn: {
    opacity: [0, 1],
    transition: {
      duration: 0.5,
    },
  } as Variants,

  // Fade out
  fadeOut: {
    opacity: [1, 0],
    transition: {
      duration: 0.3,
    },
  } as Variants,

  // Sparkle burst
  sparkle: {
    scale: [0, 1.5, 0],
    opacity: [0, 1, 0],
    transition: {
      duration: 0.8,
      ease: 'easeOut',
    },
  } as Variants,

  // Slide in from bottom
  slideInBottom: {
    y: [100, 0],
    opacity: [0, 1],
    transition: {
      duration: 0.5,
      ease: 'easeOut',
    },
  } as Variants,

  // Slide in from top
  slideInTop: {
    y: [-100, 0],
    opacity: [0, 1],
    transition: {
      duration: 0.5,
      ease: 'easeOut',
    },
  } as Variants,

  // Pulse (gentle attention getter)
  pulse: {
    scale: [1, 1.05, 1],
    transition: {
      duration: 1,
      ease: 'easeInOut',
      repeat: Infinity,
    },
  } as Variants,

  // Shake (for wrong answer, gentle)
  shake: {
    x: [0, -10, 10, -10, 10, 0],
    transition: {
      duration: 0.4,
      ease: 'easeInOut',
    },
  } as Variants,

  // Float (for leaves, bubbles)
  float: {
    y: [0, -15, 0],
    transition: {
      duration: 3,
      ease: 'easeInOut',
      repeat: Infinity,
    },
  } as Variants,

  // Spin (for celebration elements)
  spin: {
    rotate: [0, 360],
    transition: {
      duration: 2,
      ease: 'linear',
      repeat: Infinity,
    },
  } as Variants,

  // Pop in (for buttons, characters)
  popIn: {
    scale: [0, 1.2, 1],
    transition: {
      duration: 0.4,
      ease: 'easeOut',
    },
  } as Variants,

  // Pop out (for hiding elements)
  popOut: {
    scale: [1, 1.2, 0],
    transition: {
      duration: 0.3,
      ease: 'easeIn',
    },
  } as Variants,
};

/**
 * Animation presets for common interactions
 */
export const interactionAnimations = {
  tap: {
    scale: 0.95,
    transition: {
      duration: 0.1,
    },
  },

  hover: {
    scale: 1.05,
    transition: {
      duration: 0.2,
    },
  },

  press: {
    scale: 0.9,
    transition: {
      duration: 0.1,
    },
  },
};

/**
 * Page transition animations
 */
export const pageTransitions = {
  initial: {
    opacity: 0,
    scale: 0.9,
  },
  animate: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.5,
      ease: 'easeOut',
    },
  },
  exit: {
    opacity: 0,
    scale: 1.1,
    transition: {
      duration: 0.3,
      ease: 'easeIn',
    },
  },
};
